import { log } from 'Src/utils/log';

// @ts-expect-error - we have no types on our worker
import JobWorker from './job.worker.ts';
import { ConsumerMessageJobCompleted, ConsumerMessageJobError, ConsumerMessages, Printer, WorkerMessages } from './types';

declare global {
  export interface GlobalEventHandlersEventMap {
    'notify.TerminalLANPrintJobError': CustomEvent<ConsumerMessageJobError['job']>;
    'notify.TerminalLANPrintJobCompleted': CustomEvent<Pick<ConsumerMessageJobCompleted, 'job' | 'result'>>;
    'notify.LANPrinterStatusChanged': CustomEvent<Printer>;
  }
}


const setupWorker = () => {
  const jobWorker = new JobWorker() as Worker;// new Worker(new URL('job.worker.ts', import.meta.url));
  if (!jobWorker) {
    return;
  }

  jobWorker.addEventListener('message', (event: MessageEvent<ConsumerMessages>) => {
    switch (event.data.type) { 
      case 'job.completed': {
        log.info(`LAN Comms worker job completed for job ${event.data.job.jobId}`);
        const completedEvent = new CustomEvent('notify.TerminalLANPrintJobCompleted', {
          detail: {
            job: event.data.job,
            result: event.data.result,
          },
        });
        document.dispatchEvent(completedEvent);
        return;
      }
      case 'job.error': {
        log.error(`LAN Comms worker job error for job ${event.data.job.jobId}: ${event.data.job.error}`);
        const errorEvent = new CustomEvent('notify.TerminalLANPrintJobError', {
          detail: event.data.job,
        });
        document.dispatchEvent(errorEvent);
        return;
      }
      case 'printer.statusChanged': {
        log.info(`LAN Comms worker printer status changed: ${event.data.printer}`);
        const statusEvent = new CustomEvent('notify.LANPrinterStatusChanged', {
          detail: event.data.printer,
        });
        document.dispatchEvent(statusEvent);
        return;
      }
      case 'request.error': {
        log.error(`LAN Comms worker request error (${event.data.requestType}): ${event.data.error ?? event.data.job?.error}`);
        if (event.data.job) {
          const errorEvent = new CustomEvent('notify.TerminalLANPrintJobError', {
            detail: event.data.job,
          });
          document.dispatchEvent(errorEvent);
        }
        return;
      }
      default: {
        log.error('Unknown message type received from LAN Comms print job worker:', event.data);
        return;
      }
    }
  });

  document.addEventListener('notify.TerminalLANPrintJob', (e) => {
    const printJob = e.detail;
    log.info('Received TerminalLANPrintJob notification: {@printJob}', printJob);
    const msg: WorkerMessages = {
      type: 'job.received',
      job: printJob,
    };
    jobWorker.postMessage(msg);
  });
};

if (!window.Worker) {
  log.debug('Web Workers are not supported in this environment.');
} else {
  setupWorker();
}
